import { render, staticRenderFns } from "./privacy-policy-content.vue?vue&type=template&id=02b15cfc&scoped=true&"
import script from "./privacy-policy-content.vue?vue&type=script&lang=js&"
export * from "./privacy-policy-content.vue?vue&type=script&lang=js&"
import style0 from "./privacy-policy-content.vue?vue&type=style&index=0&id=02b15cfc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b15cfc",
  null
  
)

export default component.exports